import styled from "styled-components";

export const ButtonContainer = styled.div`
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : '48px'} !important;
    position: relative;
    border: ${props => props.border ? props.border : '1px solid #000'};
    border-radius: 25px !important;
    border-bottom-left-radius: ${props => props.isOpen ? '0px' : '25px'} !important;
    border-bottom-right-radius: ${props => props.isOpen ? '0px' : '25px'} !important;
    background-color: transparent;

    button {
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0.5rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 12px;
        /* transition: all 0.7s ease; */
        background-color: transparent;
        border: none;
    }

    img {
        transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
        transition: all 0.5s ease;
    }
`;

export const Options = styled.div`
    width: ${props => props.widthOption ? `calc(${props.widthOption} + 2px)` : props.width ? `calc(${props.width} + 2px)` : 'auto'};
    min-height: 40px;
    max-height: 140px;
    position: absolute;
    top: 46px;
    left: ${props => props.left ? props.left : '-1px'};
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #FFF;
    border-radius: 4px;
    border-bottom-left-radius: ${props => props.isOpen && props.hasBorder ? '25px' : '0px'} !important;
    border-bottom-right-radius: ${props => props.isOpen && props.hasBorder ? '25px' : '0px'} !important;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    border: ${props => props.border ? props.border : '1px solid #000'};
    z-index: 10;

      /* width */
    ::-webkit-scrollbar {
        width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888; 
        border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }   
`;

export const Option = styled.div`
    padding: 0.625rem;
    transition: 0.3s;
    cursor: pointer;

    font-size: 0.625rem;
    text-transform: uppercase;

    &:hover {
        background-color: rgba(238, 238, 238, 0.78);
    }
`;

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;